var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoutIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 9.49996L18.5657 8.93427L19.1314 9.49996L18.5657 10.0656L18 9.49996ZM7.07143 10.3C6.6296 10.3 6.27143 9.94178 6.27143 9.49996C6.27143 9.05813 6.6296 8.69996 7.07143 8.69996L7.07143 10.3ZM12.4943 2.86284L18.5657 8.93427L17.4343 10.0656L11.3629 3.99421L12.4943 2.86284ZM18.5657 10.0656L12.4943 16.1371L11.3629 15.0057L17.4343 8.93427L18.5657 10.0656ZM18 10.3L7.07143 10.3L7.07143 8.69996L18 8.69996L18 10.3Z",
    fill: "#15397F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.64307 1.00003L3.42878 1.00003C2.08752 1.00003 1.00021 2.08734 1.00021 3.4286L1.00021 15.5715C1.00021 16.9127 2.08752 18 3.42878 18H4.64306",
    stroke: "#15397F",
    strokeWidth: 1.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutIcon);
export default __webpack_public_path__ + "static/media/logout-icon.1dec1e7bdb9a6957e93f83ea1b90c86a.svg";
export { ForwardRef as ReactComponent };